import { inject, Injectable } from "@angular/core";
import { BehaviorSubject, catchError, finalize, map, Observable, of } from "rxjs";
import { ImportsService } from "../service/import.service";
import { Imports } from "../models/imports";
import { LoadingService } from "src/app/core/ui/loading.service";
import { ImportDiscardOption } from "../enums/import-discard-option.enum";
import { ImportState } from "../enums/import-state.enum";

@Injectable({ providedIn: 'root' })
export class ImportsStore {
    // Subujects für den Zustand
    private importsSubject = new BehaviorSubject<Imports[]>([]);
    private totalRecordSubject = new BehaviorSubject<number>(0);

    private loadingService = inject(LoadingService);

    // Öffentliche Observables
    imports$: Observable<Imports[]> = this.importsSubject.asObservable();
    totalRecords$: Observable<number> = this.totalRecordSubject.asObservable();

    constructor(private importsService: ImportsService) { }

    loadImports(vendorId: number = -99999, clientId: number = -99999, importStates: ImportState[] = [], page: number = 0, size: number = 10, sort?: string): void {
        this.loadingService.show();
        this.importsService.fetchImports(vendorId, clientId, importStates, page, size, sort).pipe(
            catchError(err => {
                throw err;
            }),
            finalize(() => this.loadingService.hide())
        ).subscribe(response => {
            this.importsSubject.next(response.items ?? []);
            this.totalRecordSubject.next(response.totalCount);
        });
    }

    discardImport(importId: number, discardOption: ImportDiscardOption): Observable<boolean> {
        this.loadingService.show();

        return this.importsService.discardImport(importId, discardOption).pipe(
            map(() => true),
            catchError(err => {
                console.error('Discard Import Error:', err);
                return of(false);
            }),
            finalize(() => this.loadingService.hide())
        );
    }

    // manueller Import
    uploadImportFile(formData: FormData): Observable<boolean> {
        this.loadingService.show();

        return this.importsService.uploadImportFile(formData).pipe(
            map(() => true),
            catchError(err => {
                throw err;
            }),
            finalize(() => this.loadingService.hide())
        );
    }

    getImportByIdFromSubject(importId: number): Imports | undefined {
        var imports = this.importsSubject.getValue().find(i => i.id == importId);
        if (imports) return imports;

        return undefined;
    }

    loadImportById(importId: number): Observable<Imports> {
        return this.importsService.fetchImportById(importId);
    }

    resetImport(importId: number): Observable<boolean> {
        this.loadingService.show();

        return this.importsService.resetImport(importId).pipe(
            map(() => true),
            catchError(err => {
                console.error('Reset Import Error:', err);
                return of(false);
            }),
            finalize(() => this.loadingService.hide())
        );
    }
}